module.exports = __webpack_public_path__ + "static/img/me1.628e072b.png";